export default {
    translation: {
        sidebar: {
            btnHome: 'Trang chủ',
            btnLogin: 'Đăng nhập',
            btnRegister: 'Đăng ký',
            btnUpdateUserInfo: 'Cập nhật thông tin',
            btnUpdatePassword: 'Cập nhật mật khẩu',
            btnLogout: 'Đăng xuất',

            lbNotLogin: 'Chưa đăng nhập',
        },
        shortcutCartMobile: {
            btnOpenMenu: 'Menu',
            btnCloseMenu: 'Đóng',
            btnNext: 'Tiếp tục',

            lbDishCount: '{{count}} món',
        },
        foodMobile: {
            btnAdd: 'Thêm',
            btnNote: 'Ghi chú',
            btnMoreInfo: 'Thông tin thêm',
            btnSeeMore: 'Xem thêm',
            btnCollapse: 'Thu gọn',
            lbOptional: 'Tuỳ chọn',
            lbDishCount: '{{count}} món',
        },
        headerMobile: {
            lbSearchFood: 'Tìm món ...',
        },
        modalNoteMobile: {
            title: 'Thêm ghi chú',

            btnSave: 'Lưu',
        },
        modalFastEditMobile: {
            btnAddOther: 'Thêm món tuỳ chỉnh khác',
            btnChange: 'Thay đổi',

            lbDefault: 'Mặc định',
        },
        modalFoodDetailsMobile: {
            btnAddToCart: 'Thêm vào giỏ',
            btnUpdateCart: 'Cập nhật giỏ',

            lbNote: 'Ghi chú',
        },
        modalMoreInfo: {
            title: 'Thông tin thêm',
        },
        modalOrderMethod: {
            title: 'Phương thức đặt hàng',
            titleSearchAddress: 'Địa chỉ của bạn',

            lbDeliver: 'Giao hàng',
            lbPickup: 'Đến cửa hàng',
            lbHadAccount: 'Bạn đã có tài khoản',
            lbAddressSaved: 'Địa chỉ đã lưu',

            mesWebOrderUnSupport: 'Dịch vụ đặt hàng trực tuyến không hỗ trợ.',
        },
        modalOverTime: {
            message: 'Ngoài giờ mở cửa',
            btnAgree: 'Đồng ý',
        },
        modalPayWithPaypal: {
            title: 'Thanh toán bằng Paypal',
        },
        modalExpireOrderSession: {
            message: 'Phiên đặt hàng hết hạn, vui lòng scan lại QRCode',
            title: 'Phiên đặt hàng hết hạn, vui lòng scan lại QRCode',
            btnAgree: 'Đồng ý',
        },
        cartMobile: {
            title: 'Giỏ hàng',

            lbTotalAmount: 'Tổng tiền',
            lbTableNumber: 'Số bàn',
            lbCartEmpty: 'Giỏ hàng trống',
            lbCash: 'Tiền mặt',
            lbCashCard: 'Dùng thẻ',
            lbDeliver: 'Giao hàng',
            lbPickup: 'Đến cửa hàng',
            lbOrderMethod: 'Phương thức đặt hàng',
            lbPaymentMethod: 'Phương thức thanh toán',
            lbCustomerName: 'Tên khách hàng',
            lbDeliverInfo: 'Thông tin giao hàng',
            lbNote: 'Ghi chú',
            lbSelectDeliverTime: 'Chọn thời gian giao',

            btnStartOrder: 'Mua hàng',
            btnSubmitOrder: 'Đặt hàng',
            btnRequestPayment: 'Yêu cầu thanh toán',

            mesRequestPaymentSuccess: 'Yêu cầu thanh toán thành công',
            mesRequestSupportSuccess: 'Gọi nhân viên hỗ trợ thành công',
            mesMinTotalMoneyRequire:
                'Tổng tiền đơn hàng không được nhỏ hơn {{minValue}}',
            mesSubmitOrderTakeAGoSuccess:
                'Cảm ơn quý khách, đơn hàng đã đặt thành công, mã đơn hàng của quý khách là: <b>{{code}}</b>',
        },
        modalOrderSuccess: {
            titleSubmitOrderSuccess: 'Đặt hàng thành công',
            titleRestaurantDoneOrder: 'Đơn hàng hoàn tất',
            titleProcessing: 'Đang chuẩn bị',
            titleAccepted: 'Đã tiếp nhận',
            titleFailed: 'Đơn hàng đã bị huỷ',

            mesSubmitOrderWebSuccess:
                'Cảm ơn quý khách, đơn hàng đã đặt thành công, mã đơn hàng của quý khách là: <b>#{{code}}</b>.',
            mesTimeIn: 'vào khoảng {{time}}',
            mesTimeAt: 'trong vòng {{minutes}} phút.',
            mesSubmitOrderSuccess: 'Đặt hàng thành công',
            mesTabletDoneSubmit: 'Vui lòng tới quầy thanh toán.',

            mesAccepted:
                'Đơn hàng <b>#{{code}}</b> của quý khách đã được nhà hàng tiếp nhận.',
            mesProcessing:
                'Đơn hàng <b>#{{code}}</b> của bạn đang được chuẩn bị, vui lòng đợi.',
            mesDonePickup:
                'Đơn hàng <b>#{{code}}</b> của quý khách đã hoàn tất, quý khác vui lòng tới nhà hàng để nhận đơn hàng',
            mesDoneDeliver:
                'Đơn hàng <b>#{{code}}</b> của quý khách đang được giao',
            mesDoneAtRestaurant:
                'Đơn hàng <b>#{{code}}</b> của quý khác đã được nhà hàng chuẩn bị xong, quý khách vui lòng tới quầy để nhận hàng.',
            mesFailed: 'Đơn hàng <b>#{{code}}</b> của quý khách đã bị hủy.',

            lbDiscount: 'Mã giảm giá',
            hintDontCloseTab: 'Vui lòng không đóng cửa sổ này!',
        },
        footer: {
            lbContact: 'Liên hệ',
            lbCopyright: '© Copyright 2021. All rights reserved by {{someone}}',
        },
        cartDesktop: {
            title: 'Giỏ hàng',
            titleRestaurantDoneOrder: 'Đơn hàng hoàn tất',

            lbCartEmpty: 'Giỏ hàng trống',
            lbAgreeTCPre: 'Bằng việc bấm vào đặt món, bạn đông ý với các',
            lbAgreeTCRest: 'bảo vệ dữ liệu của chúng tôi',
            lbTermAndCondition: 'Điều khoản và điều kiện',
            lbDeliver: 'Giao hàng',
            lbPickup: 'Đến cửa hàng',
            lbOrderMethod: 'Phương thức đặt hàng',
            lbTotalAmount: 'Tổng tiền',
            lbCash: 'Tiền mặt',
            lbPaymentMethod: 'Phương thức thanh toán',
            lbCustomerName: 'Tên khách hàng',
            lbDeliverInfo: 'Thông tin giao hàng',
            lbNote: 'Ghi chú',
            lbSelectDeliverTime: 'Chọn thời gian giao',
            lbOrderNote: 'Ghi chú cho toàn bộ đơn hàng',

            mesRestaurantDoneOrder:
                'Đơn hàng của quý khác đã được nhà hàng chuẩn bị xong, quý khách vui lòng tới quầy để nhận hàng.',
            mesRequestPaymentSuccess: 'Yêu cầu thanh toán thành công',
            mesRequestSupportSuccess: 'Gọi nhân viên hỗ trợ thành công',
            mesMinTotalMoneyRequire:
                'Tổng tiền đơn hàng không được nhỏ hơn {{minValue}}',

            btnStartOrder: 'Mua hàng',
            btnSubmitOrder: 'Đặt hàng',
        },
        headerDesktop: {
            btnUpdateUserInfo: 'Cập nhật thông tin',
            btnUpdatePassword: 'Cập nhật mật khẩu',
            btnLogout: 'Đăng xuất',
            btnLogin: 'Đăng nhập',
            btnRegister: 'Đăng ký',
        },
        button: {
            agree: 'Đồng ý',
            update: 'Cập nhật',
            register: 'Đăng ký',
            forgotPassword: 'Quên mật khẩu',
            login: 'Đăng nhập',
            logout: 'Đăng xuất',
            updatePassword: 'Cập nhật mật khẩu',
            updateUserInfo: 'Cập nhật thông tin',
            openMenu: 'Menu',
            closeMenu: 'Đóng',
            fastAddToCart: 'Thêm',
            home: 'Trang chủ',
            confirm: 'Xác nhận',
            moreInfo: 'Thông tin thêm',
            custom: 'Tuỳ chỉnh',
            note: 'Ghi chú',
            save: 'Lưu',
            addToCart: 'Thêm vào giỏ',
            updateCart: 'Cập nhật giỏ',
            change: 'Thay đổi',
            addOtherCustomFood: 'Thêm món tuỳ chỉnh khác',
            startOrder: 'Mua hàng',
            submitOrder: 'Đặt hàng',
            requestPayment: 'Yêu cầu thanh toán',
            back: 'Quay lại',
        },
        voucher: {
            discountCode: 'Mã giảm giá',
            btnVerify: 'Xác thực',
            verified: 'Đã xác thực',
            invalidVoucher: 'Mã giảm giá không hợp lệ',
            minOrderNotMet: 'Đơn hàng tối thiểu {{minValue}} để sử dụng mã này',
            voucherVerified: 'Mã giảm giá đã được chấp nhận!',
            voucherDetails: 'Chi tiết voucher',
        },
        customerInfo: {
            notLogin: 'Chưa đăng nhập',
            username: 'Tên đăng nhập',
            password: 'Mật khẩu',
            confirmPassword: 'Xác nhận mật khẩu',
            newPassword: 'Mật khẩu mới',
            confirmNewPassword: 'Xác nhận mật khẩu mới',
            firstName: 'Tên',
            phone: 'Số điện thoại',
            email: 'Email',
            office: 'Văn phòng',
            street: 'Đường',
            apartmentNumber: 'Số nhà',
            postCode: 'Mã bưu điện',
            city: 'Thành phố',
            floor: 'Tầng toà nhà',
            address: 'Địa chỉ',
            contactInfo: 'Thông tin liên hệ',
            deliveryAddress: 'Địa chỉ nhận hàng',
            otp: 'OTP',
            searchFood: 'Tìm món',
            dishCount: '{{count}} món',
            addNote: 'Thêm ghi chú',
            default: 'Mặc định',
            cash: 'Tiền mặt',
            cash_card: 'Dùng thẻ',
            tableNumber: 'Số bàn',
            orderMethod: 'Phương thức đặt hàng',
            delivery: 'Giao hàng',
            pickup: 'Tới lấy',
            totalAmount: 'Tổng tiền',
            deliveryTime: 'Thời gian giao',
            pickupTime: 'Thời gian đến lấy',
            paymentMethod: 'Phương thức thanh toán',
            paymentMethodGroupCash: 'Trực tiếp',
            paymentMethodGroupOnline: 'Trực tuyến',
        },
        // for mobile page and desktop modal
        updatePassword: {
            title: 'Cập nhật mật khẩu',
            confirm: 'Xác nhận',
        },
        // page and modal
        forgotPassword: {
            title: 'Quên mật khẩu',
            titleNewPassword: 'Mật khẩu mới',

            mesChangeSuccess: 'Cập nhật mật khẩu thành công',
        },
        // register page and update personal info page
        personalInfo: {
            titleRegister: 'Đăng ký',
            titleUpdate: 'Cập nhật thông tin',
        },
        orderDetails: {
            totalAmount: 'Tổng tiền',
        },
        orderHistory: {
            code: 'Mã',
            lbWaitingConfirm: 'Chờ xác nhận',
        },
        modalFoodChoose: {
            title: 'Chọn món',
            btnAgree: 'Đồng ý',
        },
        message: {
            minTotalMoneyRequire:
                'Tổng tiền đơn hàng không được nhỏ hơn {{minValue}}',
            messageInvalidTable:
                'Bàn không thể đặt được, vui lòng liên hệ chủ cửa hàng',
            beilageRequire: 'Nhóm {{group}} phải chọn tối thiểu một',
            waiting: 'Đang tải vui lòng chờ',
            invalidTable: 'Bàn không hợp lệ, vui lòng scan lại QRCode',
            registerSuccess: 'Đăng ký thành công',
            updateUserInfoSuccess: 'Cập nhật thành công',
            invalidAddress: 'Địa chỉ không hợp lệ',
            invalidRestaurant: 'Nhà hàng không hợp lệ',
            invalidEmail: 'Email không hợp lệ',
            fieldRequired: 'Trường này không được để trống',
            minLength: 'Trường này phải chứa tối thiểu {{minLength}} ký tự',
            confirmPasswordNotMatch: 'Xác nhận mật khẩu không khớp',
            invalidQRCode:
                'Mã QRCode không hợp lệ, vui lòng scan lại mã QRCode',
            unSupportDevice: 'Thiết bị không hỗ trợ!',
            dataNotFound: 'Không tìm thấy dữ liệu yêu cầu',
        },
    },
}
